import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import 'react-dates/initialize';
import moment from 'moment';
import {TimePicker} from 'antd';
import 'antd/lib/time-picker/style/css';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    startDateLabel: string;
    endDateLabel: string;
    wrapperClassName?: string;
    placeholder?: string;
};

type State = {
    focusedInput: any;
};

class TimePickerField extends React.PureComponent<WrappedFieldProps & Props, State> {
    constructor(props: WrappedFieldProps & Props) {
        super(props);
        this.state = {
            focusedInput: null
        };
        this.handleFocusChange = this.handleFocusChange.bind(this);
    }

    public handleFocusChange(focusedInput) {
        this.setState({focusedInput});
    }

    public render() {
        const {input, disabled, wrapperClassName, placeholder} = this.props;
        const {
            meta,
            label
        } = this.props;

        let formClasses: string = 'form-field';
        formClasses += meta.error && meta.touched ? ' form-field--error' : '';
        formClasses += wrapperClassName ? ` ${wrapperClassName} ` : '';
        formClasses += disabled ? ' form-field--disabled' : '';

        const value = (input && input.value && input.value._isValid) ? moment(input.value) : null;
        return (
            <div className={formClasses}>
                <label htmlFor={input.name}>{label}</label>
                <TimePicker value={value} format={'HH:mm'} size="large"
                            onChange={(time: moment.Moment) => {
                                input.onChange(time);
                            }} placeholder={placeholder ? placeholder : label}/>
            </div>
        );
    }
}

export default TimePickerField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/TimePickerField.tsx